export const FETCH_PARTS_START = "FETCH_PARTS_START";
export const FETCH_PARTS_SUCCESS = "FETCH_PARTS_SUCCESS";
export const FETCH_PARTS_FAIL = "FETCH_PARTS_FAIL";

export const FETCH_PARTS_DROPDOWN_START = "FETCH_PARTS_DROPDOWN_START";
export const FETCH_PARTS_DROPDOWN_SUCCESS = "FETCH_PARTS_DROPDOWN_SUCCESS";
export const FETCH_PARTS_DROPDOWN_FAIL = "FETCH_PARTS_DROPDOWN_FAIL";

export const SET_PARTS_CURRENT_PAGE = "SET_PARTS_CURRENT_PAGE";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";

export const SET_PARTS_SEARCH_INPUT = "SET_PARTS_SEARCH_INPUT";

export const GET_DROPDOWN_DETAILS_START = "GET_DROPDOWN_DETAILS_START";
export const GET_DROPDOWN_DETAILS_SUCCESS = "GET_DROPDOWN_DETAILS_SUCCESS";
export const GET_DROPDOWN_DETAILS_FAIL = "GET_DROPDOWN_DETAILS_FAIL";
export const RESET_DROPDOWN_DETAILS = "RESET_DROPDOWN_DETAILS";

export const DOWNLOAD_FILE_START = "DOWNLOAD_FILE_START";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAIL = "DOWNLOAD_FILE_FAIL";

export const ORDER_MANUAL_PART_START = "ORDER_MANUAL_PART_START";
export const ORDER_MANUAL_PART_SUCCESS = "ORDER_MANUAL_PART_SUCCESS";
export const ORDER_MANUAL_PART_FAIL = "ORDER_MANUAL_PART_FAIL";

export const EDIT_PART_DETAILS_START = "EDIT_PART_DETAILS_START";
export const EDIT_PART_DETAILS_SUCCESS = "EDIT_PART_DETAILS_SUCCESS";
export const EDIT_PART_DETAILS_FAIL = "EDIT_PART_DETAILS_FAIL";

export const FETCH_ORDER_VENDOR_START = "FETCH_ORDER_VENDOR_START";
export const FETCH_ORDER_VENDOR_SUCCESS = "FETCH_ORDER_VENDOR_SUCCESS";
export const FETCH_ORDER_VENDOR_FAIL = "FETCH_ORDER_VENDOR_FAIL";

export const FETCH_INVOICE_OCR_DETAILS_START = "FETCH_INVOICE_OCR_DETAILS_START";
export const FETCH_INVOICE_OCR_DETAILS_SUCCESS = "FETCH_INVOICE_OCR_DETAILS_SUCCESS";
export const FETCH_INVOICE_OCR_DETAILS_FAIL = "FETCH_INVOICE_OCR_DETAILS_FAIL";

export const SET_ASCENDING_SORT = "SET_ASCENDING_SORT";

export const SET_OPENED_DROPDOWN_ROW_ID = "SET_OPENED_DROPDOWN_ROW_ID";

export const DELETE_ORDER = "DELETE_ORDER";

export const RESET_PARTS_INVENTORY = "RESET_PARTS_INVENTORY";

export const ADD_TITLE = "ADD_TITLE";
